// Presentation-only mapping of AWS accounts to product/org groups. Purely
// frontend metadata — the backend already scopes which accounts a given
// user's /api/cost/by-account response contains (see aws-cost-api's
// config/teams.js), so a group only ever renders here if at least one of
// its accountIds is actually present in that response.
export const GROUP_ORDER = ["ams", "vms", "oms", "re", "core"];

export const GROUPS = {
  ams: {
    title: "AMS",
    accountIds: ["533267294395", "992382832748", "381149551014", "022691690664", "559886226431", "616795656176"]
  },
  vms: {
    title: "VMS",
    accountIds: ["565380232969", "683728592473"]
  },
  oms: {
    title: "DPR OMS/EPC",
    accountIds: ["905355901455", "291513037463"]
  },
  re: {
    title: "RE-Vortex",
    accountIds: ["485356574974", "425629233181"]
  },
  // Management + audit/log/network-hub + shared-services — governance/
  // platform accounts rather than a product with its own dev/prod split.
  core: {
    title: "Core Accounts",
    accountIds: ["895400567609", "637423503270", "488709146062", "628475584966", "318096622053", "637423276177"]
  }
};

export const ACCOUNT_DISPLAY_NAMES = {
  "533267294395": "AMS Data Engineering Production Account",
  "992382832748": "AMS Data Engineering Development Account",
  "381149551014": "AMS Production Account",
  "022691690664": "AMS Development Account",
  "559886226431": "AMS Web Portal Production Account",
  "616795656176": "AMS Web Portal Development Account",
  "565380232969": "VMS Production Account",
  "683728592473": "VMS Development Account",
  "905355901455": "DPR OMS/EPC Production Account",
  "291513037463": "DPR OMS/EPC Development Account",
  "485356574974": "RE-Vortex Production Account",
  "425629233181": "RE-Vortex Development Account",
  "895400567609": "Management Account",
  "637423503270": "Network Hub Account",
  "488709146062": "Log Account",
  "628475584966": "Audit Account",
  "318096622053": "Shared Services Production Account",
  "637423276177": "Shared Services Development Account"
};

// Raw AWS account names — needed wherever only an accountId is available
// (e.g. the trend endpoint's daily[].accounts, keyed by accountId with no
// name attached).
export const ACCOUNT_NAMES = {
  "533267294395": "Sorigin-Prod",
  "992382832748": "Sorigin-Dev",
  "381149551014": "PROD-AMS",
  "022691690664": "DEV-AMS",
  "559886226431": "AMS Web Poratl- Prod",
  "616795656176": "AMS Web Portal - Dev",
  "565380232969": "PROD-VMS",
  "683728592473": "DEV_VMS",
  "905355901455": "Prod_OMS",
  "291513037463": "Dev_OMS",
  "485356574974": "PROD-RE",
  "425629233181": "DEV-RE",
  "895400567609": "AGVO_VENTURES_PTE_LTD",
  "637423503270": "Sorigin-NetworkHub",
  "488709146062": "Log Account",
  "628475584966": "Audit account",
  "318096622053": "SharedServices-Prod",
  "637423276177": "Sorigin-SharedService"
};

// Mirrors config/orgAccounts.js's environment tags (backend). The
// management account (895400567609) is intentionally omitted — same as
// its backend `environment` being unset.
export const ACCOUNT_ENVIRONMENTS = {
  "533267294395": "prod",
  "992382832748": "dev",
  "381149551014": "prod",
  "022691690664": "dev",
  "559886226431": "prod",
  "616795656176": "dev",
  "565380232969": "prod",
  "683728592473": "dev",
  "905355901455": "prod",
  "291513037463": "dev",
  "485356574974": "prod",
  "425629233181": "dev",
  "637423503270": "prod",
  "488709146062": "prod",
  "628475584966": "prod",
  "318096622053": "prod",
  "637423276177": "dev"
};

const ACCOUNT_TO_GROUP = Object.entries(GROUPS).reduce((map, [key, group]) => {
  group.accountIds.forEach(accountId => { map[accountId] = key; });
  return map;
}, {});

export const getAccountGroupKey = (accountId) => ACCOUNT_TO_GROUP[accountId] || "core";

export const getAccountDisplayName = (account) => ACCOUNT_DISPLAY_NAMES[account.accountId] || account.name;

export const getAccountName = (accountId) => ACCOUNT_NAMES[accountId] || accountId;
